var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBehance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo-behance",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_white",
    "data-name": "Ellipse white",
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_grey",
    "data-name": "Ellipse grey",
    cx: 10,
    cy: 10,
    r: 10,
    transform: "translate(5 5)",
    fill: "#e3e3e3"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    transform: "translate(5 5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1304",
    "data-name": "Path 1304",
    d: "M26.576,35.061c0-.943-.642-.943-.642-.943H23.294v2.024h2.477C26.2,36.142,26.576,36.005,26.576,35.061Z",
    transform: "translate(-18.528 -27.137)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1305",
    "data-name": "Path 1305",
    d: "M25.935,50.846H23.294v2.425h2.519c.379-.011,1.078-.13,1.078-1.179C26.891,50.833,25.935,50.846,25.935,50.846Z",
    transform: "translate(-18.528 -40.443)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1306",
    "data-name": "Path 1306",
    d: "M63.036,44.011a1.623,1.623,0,0,0-1.6,1.4h2.98A1.35,1.35,0,0,0,63.036,44.011Z",
    transform: "translate(-48.868 -35.006)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1307",
    "data-name": "Path 1307",
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm2.18,5.9h3.743V7.02H12.18Zm-1.892,5.859c0,2.769-2.882,2.678-2.882,2.678H2.686V5.368H7.407A2.318,2.318,0,0,1,9.974,7.783,1.575,1.575,0,0,1,8.589,9.51C10.414,9.51,10.288,11.762,10.288,11.762Zm3.9,1.431c1.508,0,1.455-.976,1.455-.976h1.6c0,2.59-3.1,2.413-3.1,2.413a3.218,3.218,0,0,1-3.486-3.468,3.411,3.411,0,0,1,3.485-3.485c3.672,0,3.158,3.938,3.158,3.938h-4.7A1.476,1.476,0,0,0,14.185,13.193Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehance);
export default __webpack_public_path__ + "static/media/behance.baa173d6dfc1a81a269ab07eaf128089.svg";
export { ForwardRef as ReactComponent };